var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { modalUpdateSavingState } from './components/atoms';
import { ButtonKVBase, DefaultModal, InputKVBase } from '@/presentation/components';
import Styles from './total-savings-styles.scss';
import { IconDollar } from '@/presentation/components/icons';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
const ModalUpdateSaving = ({ validationModalUpdateSaving, manageVirtualAccounts, SAVING_CATEGORIES }) => {
    var _a, _b, _c, _d, _e;
    const [state, setState] = useRecoilState(modalUpdateSavingState);
    const { refeshAccounts } = useStudentAccounts(false);
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const initState = () => {
        setState(prev => {
            var _a, _b, _c, _d, _e;
            return Object.assign(Object.assign({}, prev), { savingName: ((_a = prev.virtualAccount) === null || _a === void 0 ? void 0 : _a.savingName) || '', savingGoal: parseFloat((_c = (_b = prev.virtualAccount) === null || _b === void 0 ? void 0 : _b.savingGoal) === null || _c === void 0 ? void 0 : _c.toString()) || 0, idCategory: ((_e = (_d = prev.virtualAccount) === null || _d === void 0 ? void 0 : _d.savingCategory) === null || _e === void 0 ? void 0 : _e.id) || null, savingNameError: '', savingGoalError: '', isFormInvalid: false, isLoading: false, dirtyFields: { savingName: false, savingGoal: false } });
        });
    };
    const closeModal = () => setState(prev => (Object.assign(Object.assign({}, prev), { virtualAccount: null })));
    const changeIdCategory = (idCategory) => setState(prev => (Object.assign(Object.assign({}, prev), { idCategory })));
    const isFormEmpty = () => state.savingName === '' || state.savingGoal <= 0 || state.idCategory === null;
    const validate = (field) => {
        const { savingName, savingGoal } = state;
        const formData = { savingName, savingGoal: parseFloat(savingGoal === null || savingGoal === void 0 ? void 0 : savingGoal.toString()) };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validationModalUpdateSaving.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.savingNameError || !!prev.savingGoalError })));
    };
    console.log('state.savingName:', state.savingName);
    const doUpdateSaving = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        try {
            const res = yield manageVirtualAccounts.updateOne({
                id: state.virtualAccount.id,
                params: {
                    savingName: state.savingName,
                    savingGoal: state.savingGoal,
                    savingCategory: {
                        id: state.idCategory
                    }
                }
            });
            if (res === null || res === void 0 ? void 0 : res.id) {
                refeshAccounts();
                setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false, virtualAccount: null })));
            }
            else {
                showCustomError('Error', 'Something went wrong, please try again later.');
            }
        }
        catch (error) {
            showCustomError('Error', 'Something went wrong, please try again later.');
        }
    });
    useEffect(() => initState(), [(_a = state === null || state === void 0 ? void 0 : state.virtualAccount) === null || _a === void 0 ? void 0 : _a.id]);
    useEffect(() => {
        if (state.savingName)
            validate('savingName');
    }, [state.savingName]);
    useEffect(() => {
        if (state.savingGoal)
            validate('savingGoal');
    }, [state.savingGoal]);
    return (React.createElement(DefaultModal, { height: "61.48", hUnit: "vh", width: "53.89", wUnit: "vw", open: !!((_b = state === null || state === void 0 ? void 0 : state.virtualAccount) === null || _b === void 0 ? void 0 : _b.id), onClose: closeModal, overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: { top: '35%' }, showClose: true },
        React.createElement("div", { className: Styles.mainWrapModal, key: `id_${(_c = state === null || state === void 0 ? void 0 : state.virtualAccount) === null || _c === void 0 ? void 0 : _c.id}` },
            React.createElement("h1", { className: Styles.t1 }, "Savings Settings"),
            React.createElement("div", { className: "d-flex", style: { gap: '2rem' } },
                React.createElement("div", { style: { padding: '1rem 0rem', width: '70%' } },
                    React.createElement(InputKVBase, { state: state, setState: setState, name: "savingName", type: "text", placeholder: "Saving name", label: "NAME", required: true, defaultValue: ((_d = state === null || state === void 0 ? void 0 : state.virtualAccount) === null || _d === void 0 ? void 0 : _d.savingName) || '' })),
                React.createElement("div", { style: { padding: '1rem 0rem', width: '30%' } },
                    React.createElement(InputKVBase, { state: state, setState: setState, name: "savingGoal", type: "number", placeholder: "Goal", label: "GOAL", leftIcon: React.createElement(IconDollar, null), required: true, defaultValue: ((_e = state === null || state === void 0 ? void 0 : state.virtualAccount) === null || _e === void 0 ? void 0 : _e.savingGoal) || 0 }))),
            React.createElement("div", { className: Styles.t2 }, "Select Category"),
            React.createElement("div", { className: Styles.categoryWrap }, SAVING_CATEGORIES.map((category, index) => (React.createElement("div", { className: state.idCategory === category.id ? Styles.itemSelected : Styles.item, key: index, onClick: () => changeIdCategory(category.id) },
                state.idCategory === category.id
                    ? React.cloneElement(category.icon, { color: 'white', fillColor: '#00A3FF', fillOpacity: 1 })
                    : category.icon,
                React.createElement("span", null, category.text))))),
            React.createElement("div", { style: { paddingTop: '2.5rem' } },
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: doUpdateSaving, disabled: state.isFormInvalid || isFormEmpty(), loading: state.isLoading }, "Confirm")))));
};
export default ModalUpdateSaving;
